import React from 'react';
import {
  ProjectDetailsFilter,
  useProjectDetailsFieldsAdminService
} from 'nekst-api';
import { useSetupAreaVersionContextRequired } from '../SetupAreaVersionContext';
import {
  BaseSetProjectDatesFieldsForm
} from '../../../projectdetails/List/BaseSetProjectDtesFieldsForm';
import { useFilterContext, useListContextRequired } from 'ui-builder';

export default function SetStartAndEndDateForMarketForm() {
  const { setupArea, setupAreaVersion } = useSetupAreaVersionContextRequired();

  const filterContext = useFilterContext<ProjectDetailsFilter>();

  const fieldsService = useProjectDetailsFieldsAdminService();

  const projectType = filterContext.filterValue?.projectType;

  const listContext = useListContextRequired();

  if (projectType && setupArea.market) {
    return (
      <BaseSetProjectDatesFieldsForm
        key={`dates-form-${projectType}-${listContext.version}`}
        projectType={projectType}
        submitFormFunc={async (data) => {
          await fieldsService.setStartAndEndDates(
            setupArea.id,
            setupAreaVersion.version,
            projectType,
            data.startDateFieldId,
            data.endDateFieldId
          );
        }}
      />
    );
  } else {
    return null;
  }

}
